import React from 'react';
import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';
import PropTypes from 'prop-types';


import VisibilityICon from '@material-ui/icons/VisibilityOff';
import Chip from '@material-ui/core/Chip';
import LockIcon from '@material-ui/icons/Lock';

import Switch from './StyleSwitch';

import Snackbar from '../../../labels/Snackbar';
import { InfoIcon, AssignedIcon, UserIcon } from '../../../../images/icons/WrapSvg';
import { types } from '../../../../const/types.task';

// eslint-disable-next-line
import style from './_styles.css';

class Task extends React.Component {
    state = {
        intervalId: undefined,
        message: undefined,
    };

    static getDerivedStateFromProps(props, state) {
        const {
            data,
            icon,
            text,
            component,
            value,
            editable,
            red,
            desactivado,
            parentDeactivated,
            column,
            allowed
        } = props;
        if (
            data !== state.data ||
            icon !== state.icon ||
            text !== state.text ||
            component !== state.component ||
            value !== state.value ||
            editable !== state.editable ||
            red !== state.red ||
            desactivado !== state.desactivado ||
            parentDeactivated !== state.parentDeactivated ||
            column !== state.column ||
            allowed !== state.allowed
        ) {
            state.data = data;
            state.icon = icon;
            state.text = text;
            state.component = component;
            state.value = value;
            state.editable = editable;
            state.red = red;
            state.desactivado = desactivado;
            state.parentDeactivated = parentDeactivated;
            state.column = column;
            state.allowed = allowed;
            return state;
        }
        return null;
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId);
    }

    handleTooltipClose = () => {
        this.setState({ message: undefined });
    };

    handleTooltipOpen = (message) => (event) => {
        const intervalId = setInterval(this.timer, 5000);
        this.setState({ intervalId: intervalId, message: message });
    };

    timer = () => {
        clearInterval(this.state.intervalId);
        this.setState({ message: undefined });
    };

    render() {
        const {
            data,
            icon,
            component,
            value,
            editable,
            red,
            desactivado,
            parentDeactivated,
            column,
            allowed
        } = this.state;
        const { icons, intl, ignoreModoTest } = this.props;
        return (
            <div key={data.codigo}
                className={'flex_full_column margin_top_9 padding_bottom_12 ' + (this.props.last ? '' : ' shadow_down_only')}
                onClick={this.props.onClick}
            >
                <div className="flex_full_row align_center">
                    <div className="flex_full_row align_center">
                        <Switch
                            data={data}
                            disabled={
                                !editable ||
                                data.disabled ||
                                !data.desactivable ||
                                parentDeactivated
                            }
                            desactivado={desactivado || parentDeactivated}
                            value={value}
                            onChange={this.props.onDeactive}
                        />
                    </div>
                    <div className="flex_auto_row">
                        {red &&
                            <Chip className="bg_lipstick c_white margin_right_2" label={intl.formatMessage({ id: 'out_range' })} />
                        }
                        {data.new &&
                            <Chip className="bg_golden_yellow c_white margin_right_2" label={intl.formatMessage({ id: 'new' })} />
                        }
                        {icons && icons.length > 0 && icons.map((i) => i)}
                        {data.mio && (
                            <div className="c_golden_yellow margin_left_12 hand">
                                <AssignedIcon />
                            </div>
                        )}
                        {data.descripcion && this.props.text !== 'type_label_textfixed' && (
                            <div className="c_golden_yellow margin_left_12 hand">
                                <InfoIcon onClick={this.handleTooltipOpen(data.descripcion)} />
                            </div>
                        )}
                        {(!editable || data.disabled || (data.modoTest && value !== undefined && value !== '' && value !== null && value.toString().length > 0 && value.toString() !== '[]')) && (
                            <div className="c_grey_blue margin_left_12">
                                <LockIcon className="c_bluish" />
                            </div>
                        )}
                        {!!data.censurado && (
                            <div className="c_lipstick margin_left_12">
                                <VisibilityICon />
                            </div>
                        )
                        }
                        {(data.usuariomodificacion || data.fechahoramodificacion) && (
                            <div className="c_bluish margin_left_12 hand">
                                <UserIcon
                                    onClick={this.handleTooltipOpen(
                                        `${data.usuariomodificacion}: ${data.fechahoramodificacion}`,
                                    )}
                                />
                            </div>
                        )}
                        <div className="flex_full text_align_center margin_left_12">{icon}</div>
                    </div>
                </div>
                <div className="flex_full_row align_center elements_from_right margin_top_6 margin_bottom_5">
                    {(data.type === types.boolean || data.type === types.action || data.type === types.real || data.type === types.number || data.type === types.auto || data.type === types.temp) &&
                        data.historialvalores && data.historialvalores.length > 0 &&
                        data.historialvalores.map((i, index) => {
                            const label = i.valor === true ? intl.formatMessage({ id: 'type_label_boolean_yes' })
                                : i.valor === false
                                    ? intl.formatMessage({ id: 'type_label_boolean_no' })
                                    : (i.valor === undefined || i.valor === null)
                                        ? "-"
                                        : i.valor;
                            return <Chip
                                key={data.codigo + 'historial' + index}
                                onClick={this.handleTooltipOpen(i.fecha + ' ' + (i.usuario ? i.usuario : ''))}
                                className={"c_white margin_right_2 " + (i.alerta ? "bg_lipstick " : "bg_cool_grey ") + (index > 1 ? "hide_on_mobile" : "")} label={label} />
                        })
                    }
                </div>
                <div
                    className={
                        'flex_full_row  ' +
                        (
                            (!editable
                                || data.disabled
                                || desactivado
                                || parentDeactivated
                                || (!ignoreModoTest && data.modoTest && value !== undefined && value !== '' && value !== null && value.toString().length > 0 && value.toString() !== '[]')
                            )
                                && !allowed ? 'disabled ' : '')
                    }
                >
                    <div className={'flex_full_column'}>
                        <div className="flex_auto_row padding_left_24 padding_top_18 padding_right_24 margin_bottom_12">
                            <div
                                className="barlow_regular_textwrap c_slate text_align_left text_wrap upper"
                                dangerouslySetInnerHTML={{ __html: data.nombre.toLowerCase() }}
                            />
                        </div>
                        <div className="flex_full_row margin_left_24 margin_bottom_24">
                            {!!data.censurado
                                ? <span className="barlow_regular_smalltext c_disabled text_align_left flex_full_row padding_top_18">
                                    {
                                        intl.formatMessage({ id: 'form_field_protected' })
                                    }
                                </span>
                                : component
                            }
                        </div>
                    </div>
                    {(!!column && !data.censurado) && column}
                </div>
                {this.state.message && (
                    <Snackbar
                        open={this.state.message !== undefined}
                        text={this.state.message}
                        onClose={this.handleTooltipClose}
                        variant="info"
                        nonavbar={true}
                    />
                )}
            </div>
        );
    }
}

Task.propTypes = {
    instance: PropTypes.object.isRequired,
    intl: intlShape.isRequired,
};

const mapStateToProps = (state) => {
    return {
        instance: state.instance,
    };
};

export default connect(
    mapStateToProps,
    null,
)(injectIntl(Task));



// WEBPACK FOOTER //
// ./src/components/complex/forms/types/Task.js